export { default } from './StaticImage';
